import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { T683S } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class T683SRepository extends RepositoryBase<T683S> {
  protected readonly KEY_PATH = 't683s';
}
